module.exports = "pegasus/assets/theme6/small/7.jpg";